import React, { useState } from "react";
import './EditServerInfo.css';
import API from '../../API';

const EditServerInfo = ({ room, accessToken }) => {
    const [serverIp, setServerIp] = useState(room.server_ip);
    const [serverPort, setServerPort] = useState(room.server_port);
    const [videoUrl, setVideoUrl] = useState(room.video_url);
    const [artistUrl, setArtistUrl] = useState(room.artist_url);

    async function updateServerInfo() {
        if (accessToken) {
            const response = await API.adminUpdateServerInfo(accessToken, { 
                room_id: room.room_id,
                server_ip: serverIp,
                server_port: serverPort,
                video_url: videoUrl,
                artist_url: artistUrl });
            if (response.status !== 204) {
                window.alert("Error updating server info", room.room_id);
                return;
            }
    
            window.alert("ServerInfo updated successfully!");
        }
    }

    return (
        <div className="info-container">
            <div className="input-container"><label htmlFor="inputRoomId">Room ID:</label><input id="inputRoomId" value={room.room_id} type="text" disabled={true} /></div>
            <div className="input-container"><label htmlFor="inputServerIP">Server IP:</label><input id="inputServerIP" type="text" value={serverIp} onChange={(e) => setServerIp(e.target.value)} /></div>
            <div className="input-container"><label htmlFor="inputServerPort">Server Port:</label><input id="inputServerPort" type="text" value={serverPort} onChange={(e) => setServerPort(e.target.value)} /></div>
            <div className="input-container"><label htmlFor="inputVideoUrl">Video URL:</label><input id="inputVideoUrl" type="text" value={videoUrl} onChange={(e) => setVideoUrl(e.target.value)} /></div>
            <div className="input-container"><label htmlFor="inputArtistUrl">Artist URL:</label><input id="inputArtistUrl" type="text" value={artistUrl} onChange={(e) => setArtistUrl(e.target.value)} /></div>
            <div className="actions-container">
                <button className="ff-button" onClick={updateServerInfo}>Update</button>
            </div>
        </div>
    )
};

export default EditServerInfo;